import { Button } from '@domgen/base-design-system-2.0/atoms/Button';
import { Modal } from '@domgen/base-design-system-2.0/molecules/Modal';
import { quoteModalContent } from '../constants/quoteModalContent';
import { OfferPanelA, OfferPanelProps } from './OfferPanelA';

const styles = {
  offerPanelModal: 'tablet:min-w-3xl w-full flex justify-center',
  offerPanelWrapper: 'bg-bg-primary py-4 px-5 rounded-radius-200',
  buttonLayoutModal:
    'flex flex-col w-full justify-center gap-space-500 tablet:flex-row tablet:items-center',
};

type QuoteUpsellModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onRegisterOnly: () => void;
  onContinueToCheckout: () => void;
  offerPanelProps: OfferPanelProps;
};

export const QuoteUpsellModal = ({
  isOpen,
  onClose,
  onRegisterOnly,
  onContinueToCheckout,
  offerPanelProps,
}: QuoteUpsellModalProps) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <div className="flex flex-col gap-space-400">
      <h1 className="text-h2 text-text-headline">{quoteModalContent.title}</h1>
      <p className="text-text-body">{quoteModalContent.description}</p>
      <div>
        <p className="text-body-large-strong text-text-link-default mb-2">
          {quoteModalContent.benefits.heading}
        </p>
        <ul className="flex flex-col gap-3 list-none text-left">
          {quoteModalContent.benefits.benefitsList.map((benefit, index) => (
            <li key={index} className="flex items-center">
              <span className="mr-2">{<benefit.icon />}</span>
              <span className="text-text-body">{benefit.text}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="flex flex-col items-center gap-space-400">
        <div className={styles.offerPanelModal}>
          <div className={styles.offerPanelWrapper}>
            <OfferPanelA {...offerPanelProps} alignment="center" displayIcon="none" />
          </div>
        </div>

        <div className={styles.buttonLayoutModal}>
          <Button variant="outline" onClick={onRegisterOnly}>
            No, register only
          </Button>
          <Button variant="primary" onClick={onContinueToCheckout}>
            Yes, protect my appliance
          </Button>
        </div>
      </div>
    </div>
  </Modal>
);
